import React from 'react'
import * as colors from 'tailwindcss/colors'

type Props = React.SVGProps<SVGSVGElement> & {
  tailwindColor?: keyof typeof colors
}

export const HourGlassIcon = ({ ...props }: Props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_2413_990" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.3819 11.9998L4.25801 4.857C3.52486 3.58715 4.4413 1.99983 5.9076 1.99983L17.4547 1.99983C18.921 1.99983 19.8375 3.58715 19.1043 4.857L14.9804 11.9998L19.1043 19.1426C19.8374 20.4125 18.921 21.9998 17.4547 21.9998H5.90759C4.44129 21.9998 3.52485 20.4125 4.258 19.1426L8.3819 11.9998Z"
        />
      </mask>
      <path
        d="M8.3819 11.9998L9.87862 12.8639C10.1873 12.3292 10.1873 11.6704 9.87862 11.1357L8.3819 11.9998ZM4.25801 4.857L5.75473 3.99287L4.25801 4.857ZM5.9076 1.99983L5.9076 3.7281L5.9076 1.99983ZM17.4547 1.99983L17.4547 0.271566L17.4547 1.99983ZM19.1043 4.857L17.6076 3.99287L17.6076 3.99287L19.1043 4.857ZM14.9804 11.9998L13.4837 11.1357C13.175 11.6704 13.175 12.3292 13.4837 12.8639L14.9804 11.9998ZM19.1043 19.1426L17.6076 20.0067L17.6076 20.0067L19.1043 19.1426ZM4.258 19.1426L2.76127 18.2785L2.76127 18.2785L4.258 19.1426ZM9.87862 11.1357L5.75473 3.99287L2.76128 5.72114L6.88518 12.8639L9.87862 11.1357ZM5.75473 3.99287C5.73103 3.95181 5.72792 3.92446 5.72826 3.90508C5.72869 3.88042 5.73602 3.84876 5.75473 3.81636C5.77344 3.78395 5.79719 3.76178 5.81834 3.74907C5.83495 3.73909 5.86019 3.7281 5.9076 3.7281L5.9076 0.271567C3.11088 0.271567 1.36292 3.2991 2.76128 5.72114L5.75473 3.99287ZM5.9076 3.7281L17.4547 3.7281L17.4547 0.271566L5.9076 0.271567L5.9076 3.7281ZM17.4547 3.7281C17.5021 3.7281 17.5274 3.73909 17.544 3.74907C17.5651 3.76178 17.5889 3.78395 17.6076 3.81636C17.6263 3.84876 17.6336 3.88042 17.6341 3.90509C17.6344 3.92447 17.6313 3.95182 17.6076 3.99287L20.601 5.72114C21.9994 3.2991 20.2514 0.271566 17.4547 0.271566L17.4547 3.7281ZM17.6076 3.99287L13.4837 11.1357L16.4771 12.8639L20.601 5.72114L17.6076 3.99287ZM13.4837 12.8639L17.6076 20.0067L20.601 18.2785L16.4771 11.1357L13.4837 12.8639ZM17.6076 20.0067C17.6313 20.0478 17.6344 20.0751 17.634 20.0945C17.6336 20.1192 17.6263 20.1508 17.6076 20.1833C17.5889 20.2157 17.5651 20.2378 17.544 20.2505C17.5274 20.2605 17.5021 20.2715 17.4547 20.2715V23.728C20.2514 23.728 21.9994 20.7005 20.601 18.2785L17.6076 20.0067ZM17.4547 20.2715H5.90759V23.728H17.4547V20.2715ZM5.90759 20.2715C5.86018 20.2715 5.83494 20.2605 5.81833 20.2505C5.79718 20.2378 5.77343 20.2157 5.75472 20.1832C5.73601 20.1508 5.72868 20.1192 5.72825 20.0945C5.72791 20.0751 5.73101 20.0478 5.75472 20.0067L2.76127 18.2785C1.36291 20.7005 3.11087 23.728 5.90759 23.728V20.2715ZM5.75472 20.0067L9.87862 12.8639L6.88518 11.1357L2.76127 18.2785L5.75472 20.0067Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_2413_990)"
      />
      <path
        d="M11.1157 15.2357C11.3303 14.9214 11.6697 14.9214 11.8843 15.2357L14.8289 19.5485C15.1885 20.0751 14.9436 21 14.4446 21H8.55537C8.05642 21 7.81154 20.0751 8.17106 19.5485L11.1157 15.2357Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const HourGlassPolygonIcon = ({ tailwindColor, ...props }: Props) => {
  return (
    <svg
      {...props}
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.79143 5.77274C4.10635 5.22729 4.89365 5.22729 5.20857 5.77274L7.68855 10.0682C8.00347 10.6137 7.60982 11.2955 6.97998 11.2955H2.02002C1.39018 11.2955 0.996533 10.6137 1.31145 10.0682L3.79143 5.77274Z"
        fill={tailwindColor ? colors[tailwindColor][500] : 'currentColor'}
      />
      <path
        d="M5.20857 8.22726C4.89365 8.77271 4.10635 8.77271 3.79143 8.22726L1.31145 3.9318C0.996533 3.38635 1.39018 2.70453 2.02002 2.70453L6.97998 2.70453C7.60982 2.70453 8.00347 3.38635 7.68855 3.9318L5.20857 8.22726Z"
        fill={tailwindColor ? colors[tailwindColor][400] : 'currentColor'}
      />
    </svg>
  )
}
